<template>
  <b-container id="container-memorama" class="bv-example-row">
    <!--<b-col lg="12" style="text-align: right;">
      <p style="text-align: right; width: 100%;">
        <button type="button" class="btn btn-primary" @click="vistaImprimir(cartasArry)">
          <i class="icon-printer"></i>&nbsp;Vista Imprimir
        </button>
      </p>
    </b-col>-->
    <b-col cols="10" class="instructions-style">
      <p>
        <strong>INSTRUCCIONES</strong>
      </p>
      <p>{{data.instrucciones}}</p>
    </b-col>
    <b-row class="text-center contenedor-memorama">
      <b-col cols="3" v-for="(carta,index) in cartasArry" :key="index">
        <b-card
          :id="`carta-${index}-brain`"
          tag="article"
          class="mb-2 main-face-card"
          no-body
          @click="mostrarData($event,index,carta.id,carta.audio);"
        ></b-card>
        <b-card
          v-if="carta.tipo == 2"
          :id="`carta-${index}`"
          tag="article"
          :style="{'background-image': 'url('+ $root.setUrlFile(carta.data) +')'}"
          class="mb-2 card-hidden img-card-show"
          no-body
        ></b-card>
        <b-card
          v-if="carta.tipo == 1"
          :id="`carta-${index}`"
          tag="article"
          class="mb-2 card-hidden img-card-show"
          no-body
        >
          <b-card-text>{{carta.data}}</b-card-text>
        </b-card>
        <audio v-if="carta.audio != null" :id="`audio-memorama-${index}`" style="display: none">
          <source :src="$root.setUrlFile(carta.audio)" />
        </audio>
      </b-col>

      <b-col cols="12">
        <b-button
          style="float: right; margin: 10px"
          class="btn btn-success"
          @click="resetMemorama"
        >Resetear Memorama</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "pre-memorama",
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          index: null,
          tag: "Memorama",
          cartas: [],
          instrucciones: "",
          data: "",
          reverso: ""
        };
      }
    }
  },
  data() {
    return {
      carta: [],
      index: null,
      cartasArry: new Array(),
      cardsOpen: 0,
      cardsId: [],
      cardValue1: "",
      cardValue2: "",
      resultFinal: new Array(),
      oportunidades: 0,
      totalPares: 0,
      paresCorrectos: 0,
    };
  },
  created() {
    this.cartasArry = this.data.cartas;
    this.cartasArry = this.cartasArry.concat(this.data.cartas);
    this.totalPares = this.cartasArry.length / 2;

    console.log(this.cartasArry);
  },
  methods: {
    mostrarData(e, index, value, audio) {
      console.log(e);
      console.log(index);
      console.log(value);
      console.log(audio);

      if (audio != null) {
        var elAudio = document.getElementById("audio-memorama-" + index);
        elAudio.play();
      }

      var htmlId = "carta-" + index;
      this.cardsOpen++;
      this.cardsId.push(htmlId);
      e.target.classList.add("card-hidden");
      var elementToShow = document.getElementById(htmlId);
      elementToShow.classList.remove("card-hidden");
      if (this.cardsOpen == 2) {
        this.cardValue2 = value;
        this.evaluarCard();
      } else {
        this.cardValue1 = value;
      }
    },
    evaluarCard() {
      console.log('total pares:',this.totalPares);
      console.log('pares correctos:',this.paresCorrectos);
      if (this.cardValue1 != this.cardValue2) {
        setTimeout(() => {
          this.retryElements();
        }, 1000);
        this.oportunidades++;
      } else {
        this.paresCorrectos++;
        if (this.totalPares == this.paresCorrectos) {
          this.$swal({
            type: "success",
            title: "¡FELICIDADES!",
            text: `Has completado la actividad con un total de ${this.oportunidades} oportunidades`,
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Aceptar"
          }).then(result => {
            if (result.value) {
            }
          });
        } else {
          this.refresValues();
        }
      }
    },
    retryElements() {
      console.log("ejecuta time");
      this.cardsId.forEach(el => {
        var elementToHidden = document.getElementById(el);
        var elementToShow = document.getElementById(el + "-brain");
        elementToHidden.classList.add("card-hidden");
        elementToShow.classList.remove("card-hidden");
      });
      this.refresValues();
    },
    refresValues() {
      this.cardsOpen = 0;
      this.cardsId = [];
      this.cardValue1 = "";
      this.cardValue2 = "";
    },
    vistaImprimir(data) {
      console.log(data);
      this.$router.push({ name: "Imprimir", params: { id: "dev" } });
      /*var element = document.getElementById("container-memorama");
      var opt = {
        margin: 0,
        filename: "myfile.pdf",
      };
      html2pdf()
        .set(opt)
        .from(element)
        .save();*/
    },
    resetMemorama() {
      var brains = document.getElementsByClassName("main-face-card");
      Array.from(brains).forEach(el => {
        el.classList.remove("card-hidden");
      });

      var cards = document.getElementsByClassName("img-card-show");
      Array.from(cards).forEach(el => {
        el.classList.add("card-hidden");
      });

      this.cartasArry = this.data.cartas;
      this.cartasArry = this.cartasArry.concat(this.data.cartas);
      this.totalPares = this.cartasArry.length / 2;
      this.cardsOpen = 0;
      this.paresCorrectos = 0;
      this.oportunidades = 0;
      this.refresValues();

    }
  }
};
</script>

<style lang="scss">
.main-face-card {
  max-width: 20rem;
  min-height: 16rem;
  background-repeat: no-repeat;
  background-image: url(/img/brain_2.png);
  background-position: center;
  cursor: pointer;
}
.card-hidden {
  display: none !important;
}
.img-card-show {
  max-width: 20rem;
  min-height: 16rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
article > p {
  margin: auto 0 !important;
  font-size: 26px;
  text-align: center;
}
</style>